import React from "react";
import styled from 'styled-components';

import Fonts from '../../constants/fonts';
import Colors from '../../constants/colors';
import Breakpoints from "../../constants/breakpoints";

import PlusIcon from "../../images/icons/icon-plus-orange.svg";

const SectionTitle = styled.h3`
	font-family: ${Fonts.Font_family.title_condensed};
	font-size: 2.25rem;
  font-weight: 100;
	line-height: 1;
	letter-spacing: 1px;
	color: ${props => props.color || Colors.Text.section_title};
  position: relative;
  margin-bottom: 8px;

  &::after {
    content: "";
    background-color: ${Colors.Basic.orange_01};
    display: block;
    width: 16px;
    height: 2px;
    position: absolute;
    bottom: -8px;
  }
`;

const SectionSubtitle = styled.p`
	font-family: ${Fonts.Font_family.sans_serif_condensed};
	font-size: 2.25rem;
	line-height: 1.3333;
  font-weight: bold;
	color: ${props => props.color || Colors.Text.section_title};
  position: relative;
  margin-top: 24px;
  margin-bottom: 24px;

  @media only screen and (max-width: ${Breakpoints.Width.laptop_medium}) {
    font-size: 2rem;
    margin-top: 16px;
  }

  @media only screen and (max-width: ${Breakpoints.Width.tablet}) {
    max-width: auto;
  }
`;

const SectionDescription = styled.p`
	font-family: ${Fonts.Font_family.sans_serif};
	font-size: 1.0625rem;
	line-height: 1.6470;
  letter-spacing: 0.2px;
	color: ${props => props.color || Colors.Text.default};
  margin-bottom: 0;
`;

const SectionList = styled.ul`
  margin: 1.5rem 0 0 0;
`;

const SectionListItem = styled.li`
  list-style: none;
  color: ${props => props.color || Colors.Text.default};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  background-image: url(${PlusIcon});
  background-position: 0 8px;
  background-repeat: no-repeat;
  padding-left: 16px;
  margin-bottom: 12px;
`;


export const ProjectSectionTitle = props => {
    return (
      <SectionTitle color={props.color} data-sal="fade" data-sal-duration="800">
        {props.children}
      </SectionTitle>
    );
}

export const ProjectSectionsubtitle = props => {
    return (
      <SectionSubtitle color={props.color} data-sal="slide-up" data-sal-delay="300" data-sal-duration="800">
        {props.children}
      </SectionSubtitle>
    );
}

export const ProjectSectionDescription = props => {
    return (
      <SectionDescription color={props.color} data-sal="slide-up" data-sal-delay="600" data-sal-duration="800">
        {props.children}
      </SectionDescription>
    );
}

export const ProjectSectionList = props => {
    return (
      <SectionList color={props.color} data-sal="slide-up" data-sal-delay="800" data-sal-duration="800">
        {props.children}
      </SectionList>
    );
}

export const ProjectSectionListItem = props => {
    return (
      <SectionListItem color={props.color}>
        {props.children}
      </SectionListItem>
    );
}